/**
 * 404和500错误页
 * @param param0
 * @returns
 */
import { serverSideTranslations } from '@/libs/next-lang/serverSideTranslations'
import { useTranslation } from '@/libs/next-lang'

export async function getServerSideProps({ res, req }) {
  const langData = await serverSideTranslations(req)
  return {
    props: { ...langData, errorCode: res.statusCode },
  }
}

export default function Page({ errorCode }: any) {
  const { t } = useTranslation()

  if (errorCode === 404) {
    return (
      <div
        style={{ width: '100%', height: '85vh' }}
        className="flex flex-row items-center justify-center"
      >
        <img
          style={{ width: '750px', height: '250px', userSelect: 'none' }}
          src={t('components:image.t2')}
          onMouseDown={e => e.preventDefault()}
          alt=""
        />
      </div>
    )
  }
  if (errorCode === 500) {
    return (
      <div
        style={{ width: '100%', height: '85vh' }}
        className="flex flex-row items-center justify-center"
      >
        <img
          style={{ width: '750px', height: '250px', userSelect: 'none' }}
          src={t('components:image.t3')}
          onMouseDown={e => e.preventDefault()}
          alt=""
        />
      </div>
    )
  }

  return null
}
